/** Filtro de texto sin tildes ni mayúsculas (foldKey) sobre una lista en memoria. Nació en /org (26/10/2026); lo usan el directorio y el selector de cliente. */
import { useMemo, useRef } from 'react';
import { foldKey } from '../../../shared/text-normalize';

export function useSearch<T>(items: readonly T[] | undefined, q: string, text: (i: T) => string): T[] {
  // `text` suele ser una lambda inline (cambia en cada render): se lee por ref para que el memo dependa solo de los datos y la búsqueda.
  const textRef = useRef(text);
  textRef.current = text;
  return useMemo(() => {
    const list = items ?? [];
    const k = foldKey(q);
    if (!k) return [...list];
    return list.filter((i) => foldKey(textRef.current(i)).includes(k));
  }, [items, q]);
}
